import { PageContainer } from '../../../shared/PageContainer';
import { useFeedback, ListAndDetail } from "@sis/react-library"
import ListIcon from '@mui/icons-material/List';
import { listAndDetailSamplesRoutes } from "../../ListAndDetailSamplesNavigation";
import { useState } from "react";
import { callMimicApi } from "../../../../utils/commonUtils";
import { CityTownDto } from "../../../sampleData/sampleDataReducer";
import { useSampleData } from "../../../sampleData/useSampleData";
import { useTheme } from '@mui/material';
import { GroupKeyType } from '@sis/react-library/ListContainer/ListContainer';
import { ListAndDetailSamplesGroupingsPageInfo } from './ListAndDetailSamplesGroupingsPageInfo';

export const ListAndDetailSamplesGroupingsPage = () => {

  const { cityTowns, countries, deleteCityTowns } = useSampleData();
  const [deleting, setDeleting] = useState(false);
  const theme = useTheme();

  const { showSuccess, showError } = useFeedback();

  const handleDelete = async (cityTownsToDelete: CityTownDto[]) => {
    try {
      // In the api call, uncomment the exception in there to test errors coming from the api
      setDeleting(true);

      await callMimicApi();
      await deleteCityTowns(cityTownsToDelete);

      setDeleting(false);
      showSuccess('The countries were deleted');
    } catch (ex) {
      showError(`An error occured: ${ex}`);
    }
  }

  const getCountryDescription = (groupKey: GroupKeyType) => {
    const country = countries.find(c => c.code === groupKey);
    return country ? country.description : groupKey;
  }

  const listItemRender = (item: CityTownDto) => <>{item.description}</>;
  const listGroupRender = (groupKey: GroupKeyType) => <>{getCountryDescription(groupKey)}</>;

  return (
    <PageContainer
      heading='List Samples - Groupings'
      icon={<ListIcon />}
      pageInfo={<ListAndDetailSamplesGroupingsPageInfo />}
    >
      <ListAndDetail
        items={cityTowns}
        keyValue={(item) => item.code}
        // You might get a sonarqube warning here saying React components should not be nested.
        // You can mark this as a false warning because Sonarqube doesn't know how the itemRender is used
        // and if it's a function that can be raised at any time then the state will be lost and everything will rerender.
        // However itemRender is only called in the initial render of the ListAndDetail component, and never rerendered
        // so it's fine to mark it as a false warning.
        itemRender={listItemRender}
        ////////////////////////////////////////////////////////////////////////////////////////////////////////
        // You can add a grouping item. 
        // This example groups by cities by their countries.
        ////////////////////////////////////////////////////////////////////////////////////////////////////////
        grouping={{
          groupKey: 'countryCode',

          // You might get a sonarqube warning here saying React components should not be nested.
          // You can mark this as a false warning because Sonarqube (like with itemRender) doesn't know how the groupRender is used
          // and if it's a function that can be raised at any time then the state will be lost and everything will rerender.
          // However groupRender is only called in the initial render of the ListAndDetail component, and never rerendered
          // so it's fine to mark it as a false warning.
          groupRender: listGroupRender,
          // You can also render differently if the list has a selection (the list will be narrower when an item is selected)
          //groupRender: (groupKey, hasSelection) => <><>{hasSelection ? '' : 'Country - '}</>{getCountryDescription(groupKey)}</>,

          groupBackground: () => theme.palette.secondary.light,
          // You can set the colour based on the groupKey or if the list has a selection (the list will be narrower when an item is selected)
          //groupBackground: (groupKey, hasSelection) => groupKey === 'UK' ? 'rgb(200, 200, 255)' : theme.palette.action.focus,

          // You can change the colour as well
          //groupColour: () => 'red',

          //groupCollapsable: false,
          //groupIndentation: 4,  // You can change the indent value
          //groupStartCollapsed: true  // If you want the group to start in a collapsed state,

          //onExpandCollapse: (groupKey, expanded) => {console.log('Expanded: ', groupKey, ' - ', expanded)}  // fires when you expand or callapse a group

          //groupHeight: () => '60px',
          // You can have nested groups
          // grouping: {
          //   groupKey: 'populationSizeCode',
          //   groupRender: (groupKey) => <>{groupKey}</>,
          //   groupBackground: () => 'rgb(240,240,240)',
          // }          
        }}
        // Below we are sayig you can search by code or description, typing in MK will bring up Milton keynes for example
        searchFields={['code', 'description']}
        listUrl={listAndDetailSamplesRoutes.groupings}
        newUrl={listAndDetailSamplesRoutes.new}
        editUrl={listAndDetailSamplesRoutes.edit}
        deleteOptions={{
          onDelete: handleDelete,
          busyDeleting: deleting
        }}
      />
    </PageContainer>
  )
}
